export enum NotificationTypeEnum {
    AssessmentAssignOwner = 'AssessmentAssignOwner', // - Assessment owner ,
    SystemAssignOwner = 'SystemAssignOwner', // - Data source owner,
    AssessmentCollabSubmitted = 'AssessmentCollabSubmitted', // - Collaborator submitted,
    AssessmentApproved = 'AssessmentApproved', // - Assessment marked as completed,
    SystemApproved = 'SystemApproved', // - Data source marked as completed,
    AssessmentNoteAdded = 'AssessmentNoteAdded', // - both Mention in assessment notes and Thread in assessment notes
    AutofillSuggestionsReady = 'AutofillSuggestionsReady', // - Mira added suggestions after the user asked for them
    AiTemplateReady = 'AiTemplateReady', // - "Create a template with AI" finished and saved; deep-links to the template
    AiTemplateFailed = 'AiTemplateFailed', // - "Create a template with AI" failed/timed out/name-taken/unnamed (variant in body)
}

export enum ChannelTypeEnum {
    InApp = 'InApp',
    Email = 'Email',
}

export interface NotificationInboxDto {
    id: string;
    agentId: string;
    companyId: string;
    /** Notification context ids from backend payload. */
    metadata?: {
        systemId?: string;
        assessmentId?: string;
        sectionId?: string;
        notesThreadId?: string;
        assessmentQuestionId?: string;
        /** AiTemplateReady deep link target (absent on AiTemplateFailed / Unnamed variants). */
        templateId?: number;
    };
    /** Related entity id (e.g. systemId for system-scoped notification types). */
    entityId?: string;
    notificationType: NotificationTypeEnum;
    title: string;
    body: string;
    isRead: boolean;
    createdAt: string;
    updatedAt: string | null;
}

export interface NotificationInboxPagedDto {
    items: NotificationInboxDto[];
    nextPage: string | null;
}

export interface GetNotificationsParams {
    IsRead?: boolean;
    NotificationType?: NotificationTypeEnum;
    NextPage?: string;
    PageSize?: number;
}

export interface JsonPatchOperation {
    op: string;
    path: string;
    value: unknown;
}

export interface NotificationSettingDto {
    notificationType: NotificationTypeEnum;
    channelType: ChannelTypeEnum;
    effectiveEnabled: boolean;
    isEditable: boolean;
    isOverridden: boolean;
}

export interface NotificationSettingPutRequest {
    notificationType: NotificationTypeEnum;
    channelType: ChannelTypeEnum;
    enabled: boolean;
}
